import { useAuthStore, useModalStore } from '@/store';

/**
 * Gate Voice Mode behind Gab AI Plus on every supported platform.
 * Shows the voice preview before the platform's existing purchase flow.
 * @param {{ source?: string }} [opts]
 * @returns {boolean} true if the user can start voice mode
 */
export function requirePlusForVoice(opts = {}) {
  const isPlus = !!useAuthStore.getState().user?.flags?.isPlus;
  if (isPlus) return true;

  const { openModal } = useModalStore.getState().actions;
  openModal('PlusFeatureModal', { feature: 'voice', ...(opts.source ? { source: opts.source } : {}) });
  return false;
}
